import * as React from 'react';
import { FlexGridItem, Box } from '@alinta-digital/asg';
import { StyledText } from '../../Common.Styled';

interface Item {
  value: string;
  dataTestId: string;
}

interface SummaryItem {
  label: Item;
  content: Item;
}

interface SummaryContent {
  leftItems?: SummaryItem[];
  rightItems?: SummaryItem[];
  dataTestId?: string;
}

export const SummaryContent: React.FC<SummaryContent> = ({
  leftItems,
  rightItems,
}) => {
  return (
    <>
      {leftItems && (
        <FlexGridItem md={6}>
          {leftItems &&
            leftItems.map(({ label, content }, index) => (
              <React.Fragment key={`left-${index}`}>
                <StyledText
                  size="small"
                  weight="bold"
                  data-testid={label.dataTestId}
                >
                  {label.value}
                </StyledText>
                <br />
                <StyledText size="small" data-testid={content.dataTestId}>
                  {content.value}
                </StyledText>
                <Box margin={{ bottom: 'xxsmall' }} />
              </React.Fragment>
            ))}
        </FlexGridItem>
      )}
      {rightItems && (
        <FlexGridItem md={6}>
          {rightItems.map(({ label, content }, index) => (
            <React.Fragment key={`left-${index}`}>
              <StyledText
                size="small"
                weight="bold"
                data-testid={label.dataTestId}
              >
                {label.value}
              </StyledText>
              <br />
              <StyledText size="small" data-testid={content.dataTestId}>
                {content.value}
              </StyledText>
              <Box margin={{ bottom: 'xxsmall' }} />
            </React.Fragment>
          ))}
        </FlexGridItem>
      )}
    </>
  );
};
